import React from "react";
import Button from "@mui/material/Button";
import final_project from "../media/25007869_Final-Project-Report.pdf";

const Academia = () => {
  const education = [
    {
      id: 1,
      degree: "Bachelor of Science (Honours) in Computer Science",
      classification: "1st Class",
      institution: "University of Reading",
      year: "2020",
      details: "Studied for 4 years including a placement year in industry. Modules included AI, Computer Vision, Software Engineering, Networks, Compilers and more.",
    },
  ];

  const projects = [
    {
      id: 1,
      title: "An Analysis of Natural Language Processing Techniques Applied to Generating Tweets",
      type: "Final Year Project",
      description:
        "Investigated the ability for recurrent neural networks (RNNs) to generate text based on a relatively small set of training data. Analyzed NLP techniques by training models on individual user tweets.",
      technologies: ["Python", "RNN", "NLP", "Neural Networks"],
      year: "2020",
      pdfLink: final_project,
    },
  ];

  const achievements = [
    {
      id: 1,
      title: "AWS Cloud Practitioner Certification",
      description: "Completed AWS Certified Cloud Practitioner exam to validate foundational cloud knowledge.",
      year: "2025",
    },
    {
      id: 2,
      title: "SnapLogic Developer Certification",
      description: "Achieved SnapLogic Developer Certification in developing new Snaps",
      year: "2024",
    },
  ];

  return (
    <>
      <div className="title">
        <h2 className="heading">learning & research.</h2>
        <p className="section-subtitle">Education, projects, and continuous growth</p>
      </div>

      <div className="academia-content">
        {/* Education Section */}
        <div className="education-section">
          <h3>Education</h3>
          {education.map((edu) => (
            <div key={edu.id} className="education-item">
              <div className="edu-header">
                <h4>{edu.degree}</h4>
                <span className="classification">{edu.classification}</span>
              </div>
              <p className="institution">{edu.institution}</p>
              <p className="year">{edu.year}</p>
              <p className="details">{edu.details}</p>
            </div>
          ))}
        </div>

        {/* Projects Section */}
        <div className="projects-section">
          <h3>Notable Projects</h3>
          {projects.map((project) => (
            <div key={project.id} className="project-item">
              <div className="project-header">
                <h4>{project.title}</h4>
                <span className="project-type">{project.type}</span>
              </div>
              <p className="project-description">{project.description}</p>

              <div className="project-tech">
                <strong>Technologies:</strong>
                {project.technologies.map((tech) => (
                  <span key={tech} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>

              <p className="project-year">Year: {project.year}</p>

              <Button
                href={project.pdfLink}
                download
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "var(--primary-color2)",
                  color: "white",
                  mt: 1,
                  "&:hover": {
                    backgroundColor: "var(--primary-color3)",
                  },
                }}
              >
                Download Report
              </Button>
            </div>
          ))}
        </div>

        {/* Achievements Section */}
        <div className="achievements-section">
          <h3>Achievements & Certifications</h3>
          <div className="achievements-grid">
            {achievements.map((achievement) => (
              <div key={achievement.id} className="achievement-item">
                <h4>{achievement.title}</h4>
                <p>{achievement.description}</p>
                <span className="achievement-year">{achievement.year}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Professional Development */}
        {/* <div className="development-section">
          <h3>Professional Development</h3>
          <p>
            Beyond formal education, I continue to expand my knowledge through:
          </p>
          <ul>
            <li>TODO: Add courses/certifications completed</li>
            <li>TODO: Add conferences attended</li>
            <li>TODO: Add publications or talks given</li>
            <li>TODO: Add community involvement</li>
          </ul>
        </div> */}
      </div>
    </>
  );
};

export default Academia;
